import { jsx as o, jsxs as f } from "react/jsx-runtime";
import { useMultiStyleConfig as d, Box as e, Badge as g } from "@chakra-ui/react";
import "../../forms/Button/Button.mjs";
import { IconButton as h } from "../../forms/Button/IconButton.mjs";
import "../../forms/Button/ButtonGroup.mjs";
import { Logo as u } from "../../branding/SgiLogo/SgiLogo.mjs";
import { BellIcon as x, CartShoppingIcon as B } from "../../icons/componentIcons.mjs";
import { getFormattedNotificationCount as b } from "./notificationFunctions.mjs";
import { Tooltip as N } from "../../overlay/Tooltip/Tooltip.mjs";
const c = ({
  "aria-label": t,
  icon: l = /* @__PURE__ */ o(u, {}),
  maxNotificationDisplayLimit: m = 99,
  notificationCount: r = 0,
  tooltipLabel: n,
  size: s = "sm",
  ...p
}) => {
  const i = d("Notification"), a = /* @__PURE__ */ o(
    h,
    {
      "aria-label": t,
      icon: l,
      variant: "ghost",
      size: s,
      sx: i.iconButton,
      ...p
    }
  );
  return /* @__PURE__ */ f(e, { sx: i.container, display: "inline-block", children: [
    n ? /* @__PURE__ */ o(N, { label: n, children: a }) : a,
    r > 0 && /* @__PURE__ */ o(e, { sx: i.badgeContainer, children: /* @__PURE__ */ o(g, { sx: i.badge, children: b(r, m) }) })
  ] });
}, M = ({ ...t }) => /* @__PURE__ */ o(c, { icon: /* @__PURE__ */ o(x, { variant: "light", size: "md" }), ...t }), T = ({ ...t }) => /* @__PURE__ */ o(c, { icon: /* @__PURE__ */ o(B, { variant: "light", size: "md" }), ...t });
export {
  c as Notification,
  M as NotificationBell,
  T as NotificationCart
};
